<template>
  <div>
    <div class="col-sm-12 row ml-0 pl-0 pr-0 mt-4">
      <div class="row">
        <CCol sm="6" md="3">
          <label for>Search</label>
          <div class="search-div position-relative">
            <input
              @input="debounceSearch()"
              class="form-control"
              placeholder="Search"
              v-model="search"
            />
            <div v-if="search !== ''" class="search-svg" @click="clearSearch()">
              <crossSVG />
            </div>
          </div>
        </CCol>
        <CCol sm="6" md="3" class="datepicker pos-r">
          <label for>Date Range</label>
          <datepicker
            v-model="joinOnDateRange"
            @input="dateChange()"
            ref="datepicker"
            :model-config="datePickerConfig"
            is-range
            :masks="{ input: 'DD/MM/YYYY' }"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="
                  !!inputValue.start && !!inputValue.end
                    ? inputValue.start + ' - ' + inputValue.end
                    : 'DD/MM/YYYY'
                "
                v-on="inputEvents.start"
                class="form-control pos-r"
                placeholder="DD/MM/YYYY"
              />
              <div
                v-if="!!inputValue.start && !!inputValue.end"
                class="cross-svg"
                @click="resetJoiningDate"
              >
                <crossSVG />
              </div>
            </template>
          </datepicker>
          <div class="calendarsvg userinputcalendar pos-a">
            <calendarSVG />
          </div>
        </CCol>
        <CCol sm="6" md="3">
          <div class="position-relative">
            <label for>CME Status</label>
            <select name id class="form-control" v-model="status" @change="refreshlist()">
              <option value="ALL">All</option>
              <option value="PENDING">Pending</option>
              <option value="APPROVED">Unpublished</option>
              <option value="REJECT">No action</option>
            </select>
            <span class="drop-icon">
              <i aria-hidden="true" class="v-icon mdi mdi-menu-down theme--light position-absolute"></i>
            </span>
          </div>
        </CCol>
      </div>
    </div>
    <div class="col-sm-12 pl-0 pr-0 mt-5">
      <div class="table-div" :class="{ 'overflow-auto': reportsList.length < 1 }">
        <table class="table userlistTable mb-0">
          <thead>
            <tr class="table-success">
              <th>Event Name</th>

              <!--2-->
              <th>Organizer's Name</th>

              <!--3-->
              <th>Organizer's Role</th>

              <!--4-->
              <th>Published on</th>

              <!--5-->
              <th>Reported By</th>

              <!--6-->
              <th>Reporter's Role</th>

              <!--7-->
              <th>Status</th>

              <!--8-->
              <th>Action</th>
            </tr>
          </thead>
          <tbody v-if="reportsList.length > 0">
            <!-- 1st row -->
            <tr
              v-for="(reports, i) in reportsList"
              :key="i"
              @refreshList="getReportInappropriate()"
            >
              <!-- Blog title -->
              <td
                v-if="reports.against_to_cme_event"
                class="text-capitalize"
              >{{ reports.against_to_cme_event.event_name }}</td>

              <!-- Writer's Name -->
              <td
                v-if="reports.against_to_cme_event"
              >{{ reports.against_to_cme_event.event_organizer }}</td>

              <!-- Writer' Role -->
              <td
                v-if="reports.against_to_cme_event"
                class="text-capitalize"
              >{{ reports.against_to_cme_event.event_organizer_role }}</td>

              <!-- Published on -->
              <td v-if="reports.created_at">{{ getDate(reports.created_at) }}</td>

              <!-- Reported By -->
              <td v-if="reports.raised_by.full_name">{{ reports.raised_by.full_name }}</td>

              <!-- Reporter's Role -->
              <td v-if="reports.raised_by_role" class="capitalize-text">{{ reports.raised_by_role }}</td>

              <!-- Status -->
              <td v-if="reports.inappropriate_status">{{ reports.inappropriate_status }}</td>

              <!-- Action -->
              <td>
                <div class="action-div small-table-padding">
                  <div>
                    <CDropdown color="link" size="lg" :caret="false" class="dropdowndocbox">
                      <template #toggler-content>
                        <verticalDotsSVG />
                      </template>
                      <CDropdownItem
                        v-if="
                          permissions.includes(
                            'CAN_UNPUBLISH_REPORT_INAPPROPRIATE'
                          ) && reports.inappropriate_status == 'PENDING'
                        "
                        @click="openRejectModal('unpublish', reports._id)"
                      >Unpublish</CDropdownItem>
                      <CDropdownItem
                        v-if="
                          permissions.includes(
                            'CAN_NO_ACTION_ON_USER_INAPPROPRIATE'
                          ) && reports.inappropriate_status == 'PENDING'
                        "
                        @click="openRejectModal('no_action', reports._id)"
                      >No Action</CDropdownItem>
                      <CDropdownItem @click="openReasonModal(reports.description)">Reason</CDropdownItem>
                    </CDropdown>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <div v-else-if="showLoader && reportsList.length === 0">
            <loader v-if="showLoader"></loader>
          </div>
          <div v-else-if="isEmpty" class="pt-5 pb-7">
            <h2 class="text-center no-data mb-0">No Data Found</h2>
          </div>
        </table>
      </div>
      <pagination
        class="pagination-block"
        v-if="reportsList.length > 0"
        :recordPerPage="recordPerPage"
        :currentPage="currentPage"
        :total="total"
        @changePage="changePage"
      />
    </div>
    <!-- reason modal start -->
    <CModal
      :show.sync="reasonModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Reason"
      color="dark"
    >
      <div class="col-sm-12">
        <h6>{{ reject_reason }}</h6>
      </div>
      <template #footer>
        <CButton color="danger" @click="reasonModal = false">Cancel</CButton>
      </template>
    </CModal>
    <CModal
      :show.sync="rejectModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Modal title 2"
      size="lg"
      color="dark"
      class="reject-modal-box"
    >
      <CTextarea
        v-model="reasonData.reason"
        type="text"
        maxlength="150"
        label="Reason"
        name="reason"
        placeholder="Reason"
        horizontal
        rows="2"
      />

      <span
        v-if="reasonData.reason === '' && alert === true"
        class="text-danger required-fields"
      >{{ requiredAlert }}</span>

      <template #header>
        <h6 class="modal-title">Reason for Reject</h6>
      </template>

      <template #footer>
        <v-btn @click="rejectModal = false" class="btn btn-danger">Cancel</v-btn>
        <v-btn class="btn btn-success" @click="closeRejectModal()">Submit</v-btn>
      </template>
    </CModal>

    <!-- reason modal end -->
  </div>
</template>

<script>
import Swal from "sweetalert2";
import config from "@/config.js";
import debounce from "lodash/debounce";
import { mapGetters } from "vuex";
import "@/assets/scss/_blogs.scss";
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
const loader = () => import("@/components/loader.vue");
import { pickSvg } from "@/views/SVG";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
export default {
  props: {
    exportCSV: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  mounted() {
    this.getReportInappropriate();
  },
  data() {
    return {
      reasonData: {
        reason: ""
      },
      showLoader: false,
      isEmpty: false,
      lastSeenDateRange: {},
      joinOnDateRange: { start: "", end: "" },
      dateRange: {
        start: "",
        end: ""
      },
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00"
        },
        end: {
          timeAdjust: "23:59:59"
        }
      },
      inactiveDays: { fromDateRange: 7, toDateRange: 1 },
      dateRangeActive: false,
      reportsList: [],
      rejectModal: false,
      reasonModal: false,
      recordPerPage: 10,
      currentPage: 1,
      totalPage: 1,
      total: 0,
      role: "cme_event",
      search: "",
      status: "ALL",
      reject_reason: "",
      alert: false,
      requiredAlert: "This field is required.",
      repID: "",
      r_status: ""
    };
  },
  methods: {
    goTo(url) {
      this.$router.push(url);
    },
    dateChange() {
      this.getReportInappropriate();
    },
    openReasonModal(reason) {
      this.reasonModal = true;
      this.reject_reason = reason;
    },
    refreshlist() {
      this.reportsList = [];
      this.getReportInappropriate();
    },
    clearSearch() {
      this.search = "";
    },
    openRejectModal(r_status, rep_ID) {
      this.rejectModal = true;
      this.repID = rep_ID;
      this.r_status = r_status;
    },
    closeRejectModal() {
      this.acceptRejectReport();
      if (this.alert === false) {
        this.rejectModal = false;
      } else {
        this.rejectModal = true;
      }
    },

    changePage(page) {
      this.currentPage = page.currentPage;
      this.getReportInappropriate();
    },
    resetJoiningDate() {
      this.joinOnDateRange = { start: "", end: "" };
      this.getReportInappropriate();
    },
    debounceSearch: debounce(function() {
      this.getReportInappropriate();
    }, 500),

    getDate(date) {
      return dayJS(date).format("Do MMMM YYYY");
    },

    acceptRejectReport() {
      let obj;
      if (this.reasonData.reason === "") {
        this.alert = true;
        return false;
      } else {
        if (this.r_status === "unpublish") {
          obj = {
            is_valid: true,
            record_id: this.repID,
            rejected_reason: this.reasonData.reason
          };
        } else {
          obj = {
            is_valid: false,
            record_id: this.repID,
            rejected_reason: this.reasonData.reason
          };
        }
        let url = `${config.BASE_URL}api/v2/admin/ticket/inappropriate/accept-reject`;

        this.$http.post(url, obj).then(response => {
          if (!!response.ok) {
            if (this.r_status === "unpublish") {
              Swal.fire({
                title: "Report Inappropriate Approved",
                icon: "success",
                showCancelButton: false,
                confirmButtonText: "Ok"
              }).then(result => {
                if (result.isConfirmed) {
                  this.refreshlist();
                }
              });
            } else {
              Swal.fire({
                title: "Report Inappropriate Rejected",
                icon: "warning",
                showCancelButton: false,
                confirmButtonText: "Ok"
              }).then(result => {
                if (result.isConfirmed) {
                  this.refreshlist();
                }
              });
            }
          }
        });
      }
    },

    getReportInappropriate() {
      this.showLoader = true;
      this.total = 0;
      let url = `${config.BASE_URL}api/v2/admin/ticket/inappropriate`;
      let params = {
        against_to_role: this.role,
        page: this.currentPage,
        record_per_page: this.recordPerPage,
        status: this.status,
        search_text: this.search,
        start_date: this.joinOnDateRange.start.toString(),
        end_date: this.joinOnDateRange.end.toString()
      };
      this.$http.post(url, params).then(response => {
        if (response.body.status) {
          this.showLoader = false;
          if (response.body.data.data.list.length) {
            this.reportsList = response.body.data.data.list;
            this.totalPage =
              response.body.data.data.total_records / this.recordPerPage;
            if (
              response.body.data.data.total_records % this.recordPerPage !==
              0
            )
              this.totalPage = parseInt(JSON.stringify(this.totalPage)) + 1;
            this.total = response.body.data.data.total_records;
          } else {
            this.reportsList = [];
            this.isEmpty = true;
          }
        }
      });
    }
  },

  components: {
    loader,
    Datepicker,
    pagination: () => import("@/views/common/Pagination"),
    ...pickSvg("crossSVG")
  }
};
</script>